/** A listing's or a hotel's own page: `/listing/12`, `/hotel/7`; not `/hotel/7/review`. */
const DETAILS_PATH = /^\/(listing|hotel)\/[^/?#]+\/?$/;

/** From `md`: below it a phone gets the card's photo flight instead (`HeroFlight`). */
const DESKTOP_MIN_WIDTH = 768;

export const detailsLoadingService = {
  /** Whether a navigation to `pathname` opens a details page. */
  isDetailsPath(pathname: string): boolean {
    return DETAILS_PATH.test(pathname);
  },

  /**
   * Whether the desktop details skeleton covers a navigation from `fromPath` to `toPath`
   * on a window `width` wide: a details page, from another page, on a wide screen.
   */
  shouldShow(fromPath: string, toPath: string, width: number): boolean {
    return (
      width >= DESKTOP_MIN_WIDTH &&
      toPath !== fromPath &&
      this.isDetailsPath(toPath)
    );
  },
};
